const typePrefix = "json-s:tYpE";

module.exports = { typePrefix };
